import type { Components, Theme } from '@mui/material';
import type { TypographyOptions, TypographyStyleOptions } from '@mui/material/styles/createTypography';

export const fontFamily = ['Montserrat', 'Arial', 'sans-serif'].join(',');

const buildVariant = (fontSize: number, fontWeight: number, lineHeightRatio: number): TypographyStyleOptions => ({
  fontFamily,
  fontSize: `${fontSize}px`,
  fontWeight,
  lineHeight: `${fontSize * lineHeightRatio}px`,
  fontStyle: 'normal',
});

export const buildTypography = (): TypographyOptions => ({
  fontFamily,
  h1: buildVariant(48, 400, 1.3),
  h2: buildVariant(34, 400, 1.5),
  h3: buildVariant(24, 400, 1.5),
  h4: buildVariant(18, 400, 1.5),
  h5: undefined,
  h6: undefined,
  subtitle1: undefined,
  subtitle2: undefined,
  body1: undefined,
  body2: undefined,
  overline: undefined,
  p16: buildVariant(16, 400, 1.5),
  p16Medium: buildVariant(16, 500, 1.5),
  p16Bold: buildVariant(16, 700, 1.5),
  p14: buildVariant(14, 400, 1.5),
  p14Medium: buildVariant(14, 500, 1.5),
  p14Bold: buildVariant(14, 700, 1.5),
  p12: buildVariant(12, 400, 1.5),
  p12Medium: buildVariant(12, 500, 1.5),
  p12Bold: buildVariant(12, 700, 1.5),
  p11: buildVariant(11, 400, 2),
  p11Medium: buildVariant(11, 500, 2),
  p11Bold: buildVariant(11, 700, 2),
  caption: {
    fontSize: 16,
  },
});

export const buildMuiTypographyComponent = (): Components<Omit<Theme, 'components'>>['MuiTypography'] => ({
  defaultProps: {
    variantMapping: {
      h1: 'h1',
      h2: 'h2',
      h3: 'h3',
      h4: 'h4',
      p16: 'p',
      p16Medium: 'p',
      p16Bold: 'p',
      p14: 'p',
      p14Medium: 'p',
      p14Bold: 'p',
      p12: 'p',
      p12Medium: 'p',
      p12Bold: 'p',
      p11: 'p',
      p11Medium: 'p',
      p11Bold: 'p',
    },
  },
});
